import { render } from "./waterChart.vue?vue&type=template&id=270665f4&scoped=true"
import script from "./waterChart.vue?vue&type=script&lang=js"
export * from "./waterChart.vue?vue&type=script&lang=js"

import "./waterChart.vue?vue&type=style&index=0&id=270665f4&scoped=true&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270665f4"]])

export default __exports__